import { useState } from 'react';

import {
  Close,
  ContentCopy,
  Send,
  VButton,
  VDialog,
  VFlex,
  VStack,
} from '@/package';

export const useIssueReportGuideModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const requiredFieldsText = `👤 User Info 
  • Email : [Your email address]
  • Company : [Your company name]
  • Workspace : [Your workspace name]
  
  🕒 Issue Occurrence Time
  • e.g., 2025-07-29 15:42 (KST)
  
  🧩 Issue Description
  • e.g., Clicking "Export as PDF" does nothing
  
  🌐 Environment
  • Browser : e.g., Chrome 114.0.5735.199
  • OS : e.g., macOS 14.2`;

  const copyRequiredFields = () => {
    navigator.clipboard.writeText(requiredFieldsText);
  };

  const sendEmail = () => {
    window.location.href = `mailto:support@vueron.com?subject=[VueX] Issue report&body=${encodeURIComponent(requiredFieldsText)}`;
  };

  const Modal = () => (
    <VDialog
      visible={isOpen}
      onUpdateVisible={setIsOpen}
      dialogMainClass="w-[824px] h-[542px]"
    >
      <VStack className="size-full bg-white p-6">
        <VFlex justify="between" className="w-full" items="center">
          <div className="text-headline-md font-bold">Issue Report Guide</div>
          <Close
            className="size-6 text-gray-400"
            role="button"
            onClick={closeModal}
          />
        </VFlex>

        <VFlex gap={1} className="size-full flex-1">
          <VStack className="h-full flex-1" items="center">
            <VStack className="mt-6 flex-1 text-body-lg" gap={1}>
              <div>
                If you encounter an issue, please send an email to{' '}
                <span className="inline-flex items-center font-bold text-blue-300">
                  [support@vueron.com{' '}
                  <ContentCopy
                    className="size-4"
                    role="button"
                    onClick={() => {
                      navigator.clipboard.writeText('support@vueron.com');
                    }}
                  />
                  ]
                </span>{' '}
                using the format.
              </div>

              <div>
                Feel free to report your issue in the language you're most
                comfortable with.
              </div>

              <div>
                All fields are required, and please provide accurate information
                as much as possible.
              </div>

              <div>
                Feel free to attach a file if it helps explain the issue.
              </div>
            </VStack>

            <VButton onClick={sendEmail} fluid>
              <VFlex gap={0.5} items="center">
                <Send className="size-4" />
                <div>Send an email</div>
              </VFlex>
            </VButton>
          </VStack>
          <VStack
            className="mt-2 w-[380px] rounded-md border border-blue-300 p-4"
            gap={1}
          >
            <VStack gap={0.25}>
              <div className="inline-flex items-center text-body-md font-bold text-blue-300">
                Email Subject{' '}
                <ContentCopy
                  className="size-4"
                  role="button"
                  onClick={() => {
                    navigator.clipboard.writeText('[VueX] Issue report');
                  }}
                />
              </div>
              <div className="text-body-lg">[VueX] Issue report</div>
            </VStack>
            <div className="h-[1px] w-full bg-gray-300" />
            <VStack gap={0.5}>
              <div className="inline-flex items-center text-body-md font-bold text-blue-300">
                Required Fields{' '}
                <ContentCopy
                  className="size-4"
                  role="button"
                  onClick={copyRequiredFields}
                />
              </div>

              <VStack gap={0.5} className="text-body-lg">
                <div>👤 User Info </div>
                <div>
                  • Email :{' '}
                  <span className="text-gray-400">[Your email address]</span>
                </div>
                <div>
                  • Company :{' '}
                  <span className="text-gray-400">[Your company name]</span>
                </div>
                <div>
                  • Workspace :{' '}
                  <span className="text-gray-400">[Your workspace name]</span>
                </div>
              </VStack>

              <VStack gap={0.5}>
                <div>🕒 Issue Occurrence Time</div>
                <div className="text-gray-400">
                  • e.g., 2025-07-29 15:42 (KST)
                </div>
              </VStack>

              <VStack gap={0.5}>
                <div>🧩 Issue Description</div>
                <div className="text-gray-400">
                  • e.g., Clicking "Export as PDF" does nothing
                </div>
              </VStack>

              <VStack gap={0.5}>
                <div>🌐 Environment</div>
                <div>
                  • Browser :{' '}
                  <span className="text-gray-400">
                    e.g., Chrome 114.0.5735.199
                  </span>
                </div>
                <div>
                  • OS : <span className="text-gray-400">e.g., macOS 14.2</span>
                </div>
              </VStack>
            </VStack>
          </VStack>
        </VFlex>
      </VStack>
    </VDialog>
  );

  return {
    isOpen,
    openModal,
    closeModal,
    Modal,
  };
};
